export default function WhenTrainingNeeded() {
  const signs = [
    {
      icon: 'ri-arrow-down-circle-line',
      title: 'Падение конверсии',
      desc: 'Количество сделок снижается, лиды есть — продаж нет. Менеджеры теряют клиентов на этапах воронки из-за слабых навыков.'
    },
    {
      icon: 'ri-user-add-line',
      title: 'Много новичков в команде',
      desc: 'В отдел пришли новые менеджеры, у каждого свой стиль работы. Нет единых стандартов — хаос в коммуникации с клиентами.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Низкий средний чек',
      desc: 'Менеджеры продают базовые продукты, не умеют делать допродажи и работать с возражениями «дорого».'
    },
    {
      icon: 'ri-user-unfollow-line',
      title: 'Высокая текучесть',
      desc: 'Новички не задерживаются — нет системы адаптации и понятных критериев оценки работы.'
    },
    {
      icon: 'ri-dislike-line',
      title: 'Потеря клиентов',
      desc: 'Постоянные клиенты уходят к конкурентам. Менеджеры не выстраивают долгосрочные отношения и не делают повторные продажи.'
    },
    {
      icon: 'ri-team-line',
      title: 'Нет единых стандартов',
      desc: 'Каждый менеджер работает по-своему, невозможно масштабировать успешные практики и контролировать качество.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Стагнация роста',
      desc: 'Отдел работает стабильно, но не растёт. Нужен рывок — выход на новые рынки, запуск сложных продуктов.'
    },
    {
      icon: 'ri-chat-check-line',
      title: 'Слабые переговорные навыки',
      desc: 'Менеджеры проигрывают сложные сделки, не умеют вести переговоры с первыми лицами и закупщиками.'
    },
    {
      icon: 'ri-computer-line',
      title: 'Не используют CRM',
      desc: 'CRM внедрена, но менеджеры её игнорируют. Руководитель не видит реальной картины воронки продаж.'
    },
    {
      icon: 'ri-emotion-sad-line',
      title: 'Демотивация команды',
      desc: 'Команда выгорает, нет энергии и драйва. Рутинные задачи «съедают» всё время, нет развития и роста.'
    }
  ];

  return (
    <section id="when-needed" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Когда компании требуется обучение отдела продаж
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Если вы узнали хотя бы 2-3 признака — пора системно заняться развитием команды. Промедление стоит денег каждый день.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {signs.map((sign, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group flex items-start gap-4">
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${sign.icon} text-lg text-white`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1.5 text-sm leading-snug">{sign.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{sign.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}